import React from 'react';
import { VisuallyHidden } from '@react-aria/visually-hidden';
export { VisuallyHidden };
export const EnableVisuallyHidden = ({ children, isEnabled, ...props }) => isEnabled ? (React.createElement(VisuallyHidden, { ...props }, children)) : (React.createElement(React.Fragment, null, children));
//# sourceMappingURL=visually-hidden.component.js.map